import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { apiCaller } from "../../../services/AxiosInstance";
import {
  getProjectById,
  updateProjectStatus,
} from "../../../store/actions/ProjectActions";
import PageTitle from "../../layouts/PageTitle";
import { Button, Card, Collapse } from "react-bootstrap";
import {
  getAgeFromDob,
  getStatusSelectStyles,
} from "../../../utils/functions/date";
import FormModal from "../../components/Modal/FormModal";
import {
  artistValidationSchema,
  artistWithRoleValidationSchema,
  scheduleValidationSchema,
} from "../../../utils/validationSchemas/MasterDataSchema";
import AddUpdateArtist from "../Artist/AddUpdate";
import AddUpdateSchedule from "../Schedule/AddUpdate";
import ArtistAvatar from "../Artist/ArtistAvatar";
import ScheduleAvatar from "../Schedule/ScheduleAvatar";
import Swal from "sweetalert2";
import {
  deleteAction,
  updateAction,
} from "../../../store/actions/CommonActions";
import { FaChevronDown } from "react-icons/fa";
import FormHandler from "../../components/Forms/FormHandler";
import { projectStatusOptions } from "../../../utils/constant";
import {
  ArtistDetails,
  ParticipationDetails,
  // ProjectBanner,
  ProjectData,
  ProjectDetailsHeader,
} from "./ProjectDetails";
import AddExistingArtist from "../../components/Forms/AddExistingArtist";
import UpdateBanner from "./forms/UpdateBanner";

export const validateScheduleTime = (values) => {
  const timeToMinutes = (time) => {
    const [h, m] = time.split(":").map(Number);
    return h * 60 + m;
  };
  const errors = {};

  const newDate = values.date;
  const newStart = timeToMinutes(values.start_time);
  const newEnd = timeToMinutes(values.end_time);

  // const conflicts = state?.schedule?.filter((slot) => slot.date === newDate);
  const conflicts = [];
  const overlap = conflicts.some((slot) => {
    const slotStart = timeToMinutes(slot.start_time);
    const slotEnd = timeToMinutes(slot.end_time);
    return newStart < slotEnd && newEnd > slotStart;
  });

  if (overlap) {
    errors.start_time = "Time overlaps with existing schedule";
    errors.end_time = "Time overlaps with existing schedule";
  }

  return errors;
};

const ProjectArtistShow = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open2, setOpen2] = useState(false);
  const { projectDetails, isLoading, ...otherrest } = useSelector((state) => state.projects);
  const { data: initiatives } = useSelector((store) => store.initiative);
  const { data: categories } = useSelector((store) => store.category);
  const { data: genres } = useSelector((store) => store.genre);

  const [showModal, setShowModal] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [editingArtist, setEditingArtist] = useState(null);
  const [editingSchedule, setEditingSchedule] = useState(null);
  const [addExistingArtistFlag, setAddExistingArtistFlag] = useState(false);

  const openExistingArtistModal = () => {
    closeEditModels();
    setTimeout(() => {
      setAddExistingArtistFlag(true);
    }, 0);
  }

  const handleEditSchedule = (schedule) => {
    closeEditModels();
    setTimeout(() => {
      reOpenScheduleModal(schedule);
    }, 0);
  };

  const reOpenScheduleModal = (schedule) => {
    setEditingSchedule(schedule);
    setShowScheduleModal(true);
  }

  useEffect(() => {
    if (id) {
      dispatch(getProjectById(id));
    }
  }, [id]);

  const fetchProjectDetails = () => {
    if (id) {
      dispatch(getProjectById(id));
    }
  };

  const handleEditArtist = (artist) => {
    // closeModal();
    closeEditModels();
    setTimeout(() => {
      reOpenArtistModal(artist);
    }, 0);
  };

  const reOpenArtistModal = (artist) => {
    setEditingArtist(artist);
    setShowModal(true);
    setAddExistingArtistFlag(false); // Close the AddExistingArtist component
  }

  const closeArtistModal = () => {
    setShowModal(false);
    setEditingArtist(null);
    fetchProjectDetails(); // Refresh project data after closing modal
  }

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    if (id && newStatus) {
      if (projectDetails.status == 'Showcase' && newStatus != "Showcase") {
        Swal.fire({
          title: "Are you change the status ?",
          text: "All the Schedules will be deleted if you change the status from Showcase!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#BE282D",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, Change it!",
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(updateProjectStatus(id, newStatus));
            navigate(`/projects/${id}`);
            Swal.fire(
              "Updated!",
              "Your project status has been updated.",
              "success"
            );
          }
        });
      } else {
        dispatch(updateProjectStatus(id, newStatus));
        fetchProjectDetails();
        navigate(`/projects/${id}`);
      }
    }
  };

  if (isLoading && !projectDetails) return <p>Loading...</p>;

  const artistModalConfig = {
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      role: "",
      mobileNumber: "",
      countryCode: "",
      city: "",
      state: "",
      gender: "",
      dob: "",
      description: "",
      projectId: id,
      profile_image: "",
      hearAbout: "admin",
      referenceLinks: [],
      portfolioPdf: "",
    },
    validationSchema: artistWithRoleValidationSchema,
    apiUrl: "artist",
    // FormComponent: AddUpdateArtist,
    FormComponent: (props) => (
      <AddUpdateArtist {...props} projectDetails={projectDetails} />
    ),
    addTitle: `Add Artist to`,
    subTitle: projectDetails?.conceptTitle,
    updateTitle: "Update Artist",
    extraProps: {},
  };
  const scheduleModalConfig = {
    initialValues: {
      showName: projectDetails?.conceptTitle,
      venue: "",
      initiative: "",
      performanceVenue: "",
      date: "",
      start_time: "",
      end_time: "",
      pre_booking: false,
      pre_booking_percentage: 10,
      pre_booking_entry_only: false,
      //   show: state?._id,
      project: id,
    },
    validationSchema: scheduleValidationSchema,
    apiUrl: "schedule",
    FormComponent: AddUpdateSchedule,
    addTitle: `Schedule the Show for`,
    subTitle: projectDetails?.conceptTitle,
    updateTitle: "Update Schedule",
    extraProps: {
      parentData: {
        // title: state?.title,
        // schedule: state?.schedule,
      },
      validate: validateScheduleTime,
    },
  };

  const closeModal = () => {
    // refetchData();
    closeEditModels();
    fetchProjectDetails();
  };

  const closeEditModels = () => {
    setAddExistingArtistFlag(false);
    setShowModal(false);
    setEditingArtist(null);
    setShowScheduleModal(false);
    setEditingSchedule(null);
  }

  const addClick = () => {
    closeEditModels();
    setTimeout(() => {
      setShowModal(true);
    });
  };
  const addSchduleClick = () => {
    closeEditModels();
    setTimeout(() => {
      setShowScheduleModal(true);
    });
  };

  const removeArtist = (artist) => {
    try {
      Swal.fire({
        title: "Are you sure to remove Artist ?",
        text: "You will not be able to recover the record !!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#BE282D",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Yes, remove!",
      })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              // Use apiCaller directly instead of Redux action
              const response = await apiCaller({
                method: "put",
                url: `projects/remove-project-artists/${artist._id}/${id}`,
                data: {}
              });

              // If we reach here, the API call was successful
              setShowModal(false);
              setEditingArtist(null);
              fetchProjectDetails();
              Swal.fire({
                title: "Deleted!",
                text: "Artist Removed Successfully.",
                icon: "success",
                confirmButtonColor: "#BE282D"
              });
            } catch (error) {
              console.log("Error removing artist:", error);
              Swal.fire("Error!", "Failed to remove artist.", "error");
            }
          }
        })
        .catch((error) => {
          console.log("Error in confirmation dialog:", error);
          Swal.fire("Error!", "Failed to remove artist.", "error");
        });
    } catch (error) {
      console.log("Error in removeArtist function:", error);
      Swal.fire("Error!", "Failed to remove artist.", "error");
    }
  };

  const removeSchedule = (schedule) => {
    try {
      Swal.fire({
        title: "Are you sure to remove Schedule ?",
        text: "You will not be able to recover the record !!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#BE282D",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Yes, remove!",
      })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              // Use apiCaller directly instead of Redux action
              const response = await apiCaller({
                method: "delete",
                url: `schedule/${schedule._id}`
              });

              // If we reach here, the API call was successful
              setShowScheduleModal(false);
              setEditingSchedule(null);
              fetchProjectDetails();
              Swal.fire({
                title: "Deleted!",
                text: "Schedule Removed Successfully.",
                icon: "success",
                confirmButtonColor: "#BE282D"
              });
            } catch (error) {
              console.log("Error removing schedule:", error);
              Swal.fire("Error!", "Failed to remove schedule.", "error");
            }
          }
        })
        .catch((error) => {
          console.log("Error in confirmation dialog:", error);
          Swal.fire("Error!", "Failed to remove schedule.", "error");
        });
    } catch (error) {
      console.log("Error in removeSchedule function:", error);
      Swal.fire("Error!", "Failed to remove schedule.", "error");
    }
  };

  return (
    <>
      <PageTitle
        activeMenu="Projects"
        motherMenu="Form"
        to="/projects"
        pageContent="Project Artists show"
      />
      <div className="container-mxw">
        <ProjectDetailsHeader projectDetails={{ ...projectDetails }} refetchData={fetchProjectDetails} handleStatusChange={handleStatusChange} />

        <div>
          <div className="filter cm-content-box box-primary">
            <div
              className={`content-title SlideToolHeader ${open2 ? "collapse" : "expand"
                }`}
              onClick={() => setOpen2(!open2)}
            >
              <div className="cpa">
                <h5 className="mb-0 text-primary fw-semibold project-title">
                  Project Proposal Details
                </h5>
              </div>
              <div className="tools">
                <Link to={"#"}>
                  <FaChevronDown />
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt project-details-card">
                <div className="card-body py-3">
                  <ProjectData project={projectDetails} />
                  <h5 className="mb-2 mt-5 text-primary fw-semibold project-title">
                    About Lead Artist
                  </h5>
                  <div className="d-flex gap-4">
                    <div className="w-100">
                      <ArtistDetails projectDetails={projectDetails} />
                    </div>
                    <div className="ms-5 w-100">
                      <ParticipationDetails projectDetails={projectDetails} />
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
        <div className="d-flex flex-wrap">
          <div className="col-6">
            <div>
              <Card className="col-12">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <h5 className="mb-0 text-primary fw-semibold project-title">
                      Artists
                    </h5>

                    <div className="d-flex gap-4">
                      <button
                        onClick={() => !addExistingArtistFlag ? openExistingArtistModal() : null}
                        type="button"
                        // disabled={!state?._id}
                        className="btn d-flex gap-2 me-2 btn-outline-primary disabled-invert-color"
                      >
                        <span>
                          Add Existing Artist
                        </span>
                        <span>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.0001 8.32715V15.6535" stroke="#BE282D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.6668 11.9904H8.3335" stroke="#BE282D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="#BE282D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </span>
                      </button>
                      <button
                        onClick={addClick}
                        type="button"
                        // disabled={!state?._id}
                        className="btn d-flex gap-2 me-2 btn-outline-primary disabled-invert-color"
                        style={{ width: "110px" }}
                      >
                        <span>
                          Artist
                        </span>
                        <span>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.0001 8.32715V15.6535" stroke="#BE282D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.6668 11.9904H8.3335" stroke="#BE282D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="#BE282D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </span>
                      </button>

                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <div className="d-flex gap-4 flex-wrap">
                    {projectDetails?.artist ? (
                      <ArtistAvatar
                        allowDelete={false}
                        // allowEdit={false}
                        artist={projectDetails?.artist}
                        role={projectDetails?.ArtistProject?.find(x => x.artist == projectDetails.artist._id)?.role ?? ""}
                        handleClick={() =>
                          handleEditArtist(projectDetails?.artist)
                        }
                        removeArtist={() =>
                          removeArtist(projectDetails?.artist)
                        }
                      />
                    ) : null}
                    {projectDetails?.otherArtists &&
                      projectDetails?.otherArtists?.length > 0 ? (
                      projectDetails?.otherArtists?.map((artist) => (
                        <ArtistAvatar
                          artist={artist}
                          handleClick={() => handleEditArtist(artist)}
                          removeArtist={() => removeArtist(artist)}
                          role={projectDetails?.ArtistProject?.find(x => x.artist == artist._id)?.role ?? ""}
                        />
                      ))
                    ) : projectDetails?.artist ? null : (
                      <p>No Artists Added Yet</p>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </div>

            <div>
              <Card className="col-12">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <h5 className="text-primary fw-semibold project-title">
                      Shows
                    </h5>

                    <button
                      onClick={addSchduleClick}
                      type="button"
                      // disabled={!state?._id}
                      className="btn d-flex gap-2 me-2 btn-outline-primary disabled-invert-color"
                    >
                      <span>
                        Schedule
                      </span>
                      <span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.0001 8.32715V15.6535" stroke="#BE282D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M15.6668 11.9904H8.3335" stroke="#BE282D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="#BE282D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </span>
                    </button>
                  </div>
                </Card.Header>
                <Card.Body>
                  {projectDetails?.schedule &&
                    projectDetails?.schedule?.length > 0 ? (
                    <div className="d-flex gap-4 flex-wrap">
                      {projectDetails?.schedule?.map((schedule) => (
                        <ScheduleAvatar
                          schedule={schedule}
                          handleClick={() => handleEditSchedule(schedule)}
                          removeSchedule={(e) => {
                            e.stopPropagation();
                            removeSchedule(schedule);
                          }}
                        />
                      ))}
                    </div>
                  ) : (
                    <p>No Schedule Added Yet</p>
                  )}
                </Card.Body>
              </Card>
            </div>
            <div>
              {/* <ProjectBanner projectDetails={projectDetails} callBack={fetchProjectDetails} /> */}
              <UpdateBanner projectDetails={projectDetails} callBack={fetchProjectDetails} />
            </div>
          </div>
          <div className="col-6 ps-4">
            {showModal ? (
              <FormHandler
                modalConfig={{
                  ...artistModalConfig,
                  // initialValues: {
                  //   ...artistModalConfig.initialValues,
                  //   //   show: state?._id ?? null,
                  // },
                  initialValues: editingArtist
                    ? {
                      ...artistModalConfig.initialValues,
                      ...editingArtist,
                      role: projectDetails?.ArtistProject?.filter(x => x.artist == editingArtist._id)[0]?.role,
                      projectId: id,
                      hearAbout: editingArtist.hearAbout || "admin",
                    }
                    : {
                      ...artistModalConfig.initialValues,
                      projectId: id,
                    },
                  showModal,
                  setShowModal,
                  closeModal: closeArtistModal,
                }}
              />
            ) : showScheduleModal ? (
              <FormHandler
                modalConfig={{
                  ...scheduleModalConfig,
                  initialValues: editingSchedule ? {
                    ...scheduleModalConfig.initialValues,
                    ...editingSchedule,
                    performanceVenue: editingSchedule?.performanceVenue?._id,
                    venue: editingSchedule?.venue?._id,
                    initiative: editingSchedule?.initiative?._id,
                    project: id,
                  } : {
                    ...scheduleModalConfig.initialValues,
                    //   show: state?._id ?? null,
                  },
                  extraProps: editingSchedule ? {
                    ...editingSchedule
                  } : null,
                  showModal: showScheduleModal,
                  setShowModel: setShowScheduleModal,
                  closeModal,
                }}
              />
            ) : addExistingArtistFlag ? (
              <AddExistingArtist modalConfig={{ projectId: id, closeModal, showModal: addExistingArtistFlag, onAdd: handleEditArtist }} />
            ) : null}
          </div>
        </div>
      </div>

    </>
  );
};

export default ProjectArtistShow;
